import type {GitHubRepository} from './GitHubRepository.js'

export const gitHubRepositoryFixture = {
  id: 1234,
  connectionId: 'conn-1',
  name: 'foo/bar',
  projectId: 'pr-1',
} satisfies GitHubRepository
